export enum OrderStatus {
  Pending = 'pending',
  OutForDelivery = 'out_for_delivery',
  Delivered = 'delivered',
  Failed = 'failed',
  Canceled = 'canceled',
  Confirmed = 'confirmed',
  return = 'return',
}


export enum CancelStatus {
  Pending = 'pending',
  InProgress = 'in_progress',
  Confirmed = 'confirmed'
}

export interface Cancel {
  status: CancelStatus;
}

export enum ReturnReason {
  ItemArrivedDamagedOrBroken = 'the_item_arrived_damaged_or_broken',
  ReceivedDifferentItem = 'i_received_a_different_item_than_what_I_ordered',
  ItemNotAsDescribed = 'the_item_is_not_as_described_or_pictured',
  ItemMissingParts = 'the_item_is_missing_parts_or_accessories',
  ItemDefective = 'the_item_is_defective_or_not_working',
  ItemArrivedLate = 'the_item_arrived_too_late',
  PoorQuality = 'the_item_quality_is_poor_or_unacceptable',
  IncorrectSizeColorVariant = 'the_size_color_or_variant_is_incorrect',
  Other = 'other',
}

export enum ReturnStatus {
  Requested = 'requested',
  RequestRejected = 'request_rejected',
  RequestApproved = 'request_approved',
  InTransit = 'in_transit',
  Received = 'received',
  RefundApproved = 'refund_approved',
  RefundRejected = 'refund_rejected',
}

export enum OrderCancellationReason {
  ChangeOfMind = 'change_of_mind',
  FoundBetterPrice = 'found_better_price',
  DeliveryDelay = 'delivery_delay',
  PurchasedFromBranch = 'purchased_from_branch',
  FinancialConditions = 'financial_conditions',
  IncorrectShippingAddress = 'incorrect_shipping_address',
  IncorrectShippingMethod = 'incorrect_shipping_method',
  IncorrectPaymentInformation = 'incorrect_payment_information',
  Other = 'other',
}